import React from "react";
import { Home } from '../modules/Home';
import { Whatabkt_explain } from '../modules/Whatabkt_explain'

export const HomePage = () =>{
    return (
        <>
            <Home />
        </>
    );
};